import {
	getSubscriptionRemaining,
	isSubscriptionExpired,
	isSubscriptionExpiringSoon,
	PluralTranslatePipe,
	Role,
	Vehicle,
} from '@agilox/common';
import { EmptyPipe } from '@agilox/pipe/empty';
import { CheckboxComponent, IconModule, PillComponent, TooltipModule } from '@agilox/ui';
import { SelectOption } from '@agilox/ui-common';
import { Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { VehicleOptionTooltipPipe } from './pipes/vehicle-option-tooltip.pipe';

@Component({
	selector: 'vehicle-select-option',
	templateUrl: './vehicle-select-option.component.html',
	imports: [
		CheckboxComponent,
		IconModule,
		TranslateModule,
		TooltipModule,
		PillComponent,
		VehicleOptionTooltipPipe,
		PluralTranslatePipe,
		EmptyPipe,
	],
})
export class VehicleSelectOptionComponent {
	option = input.required<SelectOption<Vehicle>>();
	selected = input<boolean>(false);
	displayPills = input<boolean>(false);
	displayVehicleModel = input<boolean>(false);
	unionSelected = input.required<boolean>();
	isDisabled = input<boolean>(false);
	role = input<Role>(Role.support);

	toggleItem = output<Vehicle>();
	selectWholeUnion = output<void>();

	isInternalUser = computed(() => {
		// special case => partner is treated as an internal user
		return this.role() !== Role.customer;
	});

	shouldHideUnion = computed(() => {
		// Hide union when union is selected and (role is internal OR role is customer)
		return this.unionSelected() && (this.isInternalUser() || this.role() === Role.customer);
	});

	shouldHideCustomer = computed(() => {
		// Hide customer when union is selected and role is internal
		return this.unionSelected() && this.isInternalUser();
	});

	toggleItemHandler(option: SelectOption<Vehicle>): void {
		if (!option.isDisabled && option.value) {
			this.toggleItem.emit(option.value);
		}
	}

	onCheckboxClick(event: MouseEvent) {
		event.stopPropagation();
		event.preventDefault();
		event.stopImmediatePropagation();
		this.toggleItemHandler(this.option());
	}

	onSelectWholeUnion(option: SelectOption<Vehicle>, event: MouseEvent) {
		event.stopImmediatePropagation();
		event.preventDefault();
		event.stopPropagation();
		if (!option.isDisabled) {
			this.selectWholeUnion.emit();
		}
	}

	protected readonly Role = Role;
	protected readonly getSubscriptionRemaining = getSubscriptionRemaining;
	protected readonly isSubscriptionExpired = isSubscriptionExpired;
	protected readonly isSubscriptionExpiringSoon = isSubscriptionExpiringSoon;
}
